import { SOURCE_NAMES, type SourceName, type StreamRef } from '@/types/streaming';

// miruro leads: it's the only anime source currently healthy (animekai's host
// is dead, animepahe is Cloudflare-walled). Order matters because pickAlternates
// only returns the first two — with the broken sources leading, failover never
// reached a working provider.
const ANIME_SOURCES: SourceName[] = [
  'miruro-sub',
  'miruro-dub',
  'animekai-sub',
  'animekai-dub',
  'animepahe-sub',
  'animepahe-dub',
];

// Mirror of the backend's provider.supports.tv === false flags. Drift means:
// a TV-incompatible source could be returned as an alternate; the backend
// would respond `not_supported` on resolve and the chain would skip — failover
// hook would then mark THIS alternate as failing and rotate to the next.
const TV_UNSUPPORTED: SourceName[] = ['moviesapi', 'moviesapi-vip', 'ridomovies'];

export function pickAlternates(ref: StreamRef, current: SourceName | null): SourceName[] {
  const isAnime = ref.type === 'anime';
  const pool = isAnime
    ? ANIME_SOURCES
    : (SOURCE_NAMES as readonly SourceName[]).filter((n) => !ANIME_SOURCES.includes(n));
  const filtered = pool.filter((n) => {
    if (n === current) return false;
    if (ref.type === 'tv' && TV_UNSUPPORTED.includes(n)) return false;
    return true;
  });
  return filtered.slice(0, 2);
}
